import type { BillingAccessState, BillingInfo, BillingRecord } from "./types";

const requiredBillingFields: (keyof BillingRecord)[] = [
  "name",
  "surname",
  "phone",
  "addr_country",
  "addr_city",
  "addr_street",
  "addr_postal",
];

function hasBillingValue(value: string | null | undefined): boolean {
  return typeof value === "string" && !["", "none", "null"].includes(value.trim().toLowerCase());
}

export function hasBillingRecord(record: BillingRecord): boolean {
  return requiredBillingFields.every((field) => hasBillingValue(record[field]));
}

export function hasBillingDetails(billing?: BillingInfo): boolean {
  return Boolean(billing && (hasBillingRecord(billing.inUse) || hasBillingRecord(billing.waiting)));
}

export function hasWaitingBillingDetails(billing?: BillingInfo): boolean {
  return Boolean(billing && hasBillingRecord(billing.waiting));
}

export function billingAccessState(billing?: BillingInfo): BillingAccessState | undefined {
  if (!billing) return undefined;
  if (billing.accessState) return billing.accessState;
  if (!hasBillingDetails(billing)) return "billing_required";
  if (hasWaitingBillingDetails(billing) || !billing.verified) return "verification_pending";
  return "verified";
}
